import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const VerificationPendingOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_1304_53971)">
      <Path
        d="M17.4498 4.96653C17.4415 4.79153 17.3581 4.62486 17.2248 4.49986C17.0915 4.3832 16.9165 4.32486 16.7415 4.3332C13.4665 4.54986 10.9498 2.24153 10.9248 2.21653C10.6581 1.96653 10.2415 1.9832 9.99148 2.24153C7.83314 4.5082 4.29148 4.32486 4.25814 4.32486C4.08314 4.31653 3.90814 4.37486 3.77481 4.49153C3.64148 4.6082 3.56648 4.77486 3.54981 4.94986C3.27481 10.3582 3.85814 16.1165 10.3331 17.8332C10.3915 17.8499 10.4498 17.8582 10.5081 17.8582C10.5665 17.8582 10.6248 17.8582 10.6831 17.8332C17.1498 16.1165 17.7415 10.3499 17.4665 4.94986L17.4498 4.96653ZM10.4998 16.5165C6.29148 15.3249 4.63314 12.1499 4.84981 5.66653C6.04148 5.61653 8.55814 5.3082 10.4998 3.59986C11.4081 4.29153 13.4915 5.62486 16.1415 5.6832C16.3581 12.1582 14.6998 15.3332 10.4915 16.5165H10.4998Z"
        fill={color}
      />
      <Path
        d="M10.4999 11.6831C10.2165 11.6831 9.99154 11.7748 9.8082 11.9664C9.62487 12.1581 9.5332 12.3831 9.5332 12.6581C9.5332 12.9331 9.62487 13.1581 9.8082 13.3498C9.99154 13.5331 10.2249 13.6331 10.4999 13.6331C10.7749 13.6331 10.9999 13.5414 11.1832 13.3498C11.3665 13.1664 11.4582 12.9331 11.4582 12.6581C11.4582 12.3831 11.3665 12.1581 11.1832 11.9664C10.9999 11.7831 10.7749 11.6831 10.4999 11.6831Z"
        fill={color}
      />
      <Path
        d="M10.4998 6.46631C10.1915 6.46631 9.94147 6.54964 9.73314 6.72464C9.5248 6.89964 9.4248 7.13298 9.4248 7.43298C9.4248 7.49964 9.4248 7.54964 9.43314 7.59131L9.9498 10.6996C9.9748 10.8746 10.0415 11.008 10.1331 11.0996C10.2331 11.1913 10.3498 11.2413 10.4915 11.2413C10.6331 11.2413 10.7498 11.1913 10.8498 11.0996C10.9498 11.008 11.0081 10.8746 11.0248 10.6996L11.5581 7.59964C11.5581 7.59964 11.5665 7.50798 11.5665 7.44131C11.5665 7.14131 11.4665 6.90798 11.2665 6.73298C11.0665 6.55798 10.8081 6.47464 10.4998 6.47464V6.46631Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1304_53971">
        <Rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default VerificationPendingOutlined
